import { AgGridReact } from 'ag-grid-react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import { AddLocationForm } from '../add-location-form';

type AddLocationDialogProps = {
  gridRef?: React.RefObject<AgGridReact>;
  fertilizationSiteId?: string;
  visible: boolean;
  onHide: () => void;
};

export const AddLocationDialog = ({
  gridRef,
  fertilizationSiteId,
  visible,
  onHide,
}: AddLocationDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('storageLocation.addNewStorageLocation')}
      modal
      className="w-[600px] max-w-[95vw]"
    >
      <AddLocationForm
        gridRef={gridRef}
        fertilizationSiteId={fertilizationSiteId}
        onCancel={onHide}
        onSuccess={() => {
          gridRef?.current?.api?.refreshInfiniteCache();
        }}
      />
    </Dialog>
  );
};
